import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../utils/permissions";

const AdminRoute = ({ children, resource, action }) => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);
  const { hasPermission } = usePermissions();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If resource and action are provided, check permission
  if (resource && action) {
    if (!hasPermission(resource, action)) {
      return <Navigate to="/dashboard" replace />;
    }
  } else {
    // Default: check if user is admin
    if (user?.role !== "admin") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default AdminRoute;

